<template>
  <li v-if="!item.children" @click="toggleOffMobileMenu()">
    <router-link :to="item.path">
      <i :class="item.icon"></i>
      {{ item.name }}
    </router-link>
  </li>
  <li :class="{'menu-open': isOpen}" v-else>
    <a @click="isOpen = !isOpen" :class="{'router-link-active': isSelected}">
      <i :class="item.icon"></i>
      {{ item.name }}
      <i class="fas fa-chevron-right"></i>
    </a>
    <ul class="menu-dropdown">
      <TheMenuItem v-for="(children, index) in item.children" :key="index" :item="children" />
    </ul>
  </li>
</template>

<script>
import TheMenuItem from "../components/TheMenuItem";
import { mapMutations} from "vuex";

export default {
  name: "TheMenuItem",
  components: { TheMenuItem },
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    isActive() {
      return this.toggleActive;
    },
    isSelected() {
      if (this.item.children) {
        return this.$route.matched.some(
          record => record.name === this.item.name
        );
      }
      return false;
    }
  },
    methods: {
    ...mapMutations("app", ["toggleOffMobileMenu"]),
  },
  data() {
    return {
      isOpen: false
    };
  },
  created() {
    if (this.item.children) {
      this.isOpen = this.isSelected;
    }
  }
};
</script>